var utils = require('../../utils')

export default {
  name: 'profile-edit',
  created () {
    this.search()
  },
  data () {
    return {
      callbackflg: false,
      specialSkill: null,
      hobby: null,
      singleWord: null,
      uploadFlg: false,
      upFlg: false,
      clicked: false,
      isDeleteImage: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters.profileDetail
    },
    isMyself () {
      return this.$route.params.id === window.localStorage.getItem('user_id')
    },
    profileImagePath () {
      return this.profile.attributes['profile-image-path'] ? this.profile.attributes['profile-image-path'] : ''
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    uploadError() {
      return this.$store.getters.imageUploadError
    }
  },
  methods: {
    search: function() {
      var self = this
      var data = {}
      var callback
      callback = function() {
        self.callbackflg = true
        self.specialSkill = self.profile.attributes['special-skill']
        self.hobby = self.profile.attributes['hobby']
        self.singleWord = self.profile.attributes['single-word']
      }
      if (this.isMyself) {
        this.$store.dispatch('PROFILE_EDIT',  {id: this.$route.params.id, data: data, callback: callback})
      } else {
        this.$router.push('/profile/' + this.$route.params.id)
      }
    },
    onFileDummyClick: function (event) {
      document.getElementById('file').click()
    },
    onFileChange: function (event) {
      console.log('onFileChange')
      var files = event.target.files || event.dataTransfer.files
      this.upload(files[0])
    },
    onFileDelete: function(event) {
      this.profileImage = null
      this.profile.attributes['profile-image-path'] = null
      this.isDeleteImage = true
    },
    upload: function (file) {
      this.upFlg = true
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        self.profileImage = e.target.result
        var formData = new FormData()
        formData.append('profile_image', file)
        self.$store.dispatch('PROFILE_IMAGE_UPLOAD', { data: formData, callback: self.onUpload, errorCallback: self.notUpload })
      }
      reader.readAsDataURL(file)
    },
    onUpload: function (data) {
      this.profile.attributes['profile-image-path'] = data.image_path
      this.uploadFlg = true
    },
    notUpload: function () {
      this.profileImage = null
    },
    onClickSave: function() {
      this.clicked = true
      var data = {
        id: this.$route.params.id,
        profile_image: this.profileImage,
        is_delete_image: this.isDeleteImage,
        special_skill: this.specialSkill,
        hobby: this.hobby,
        single_word: this.singleWord,
        asovi_access_token: window.localStorage.getItem('access_token')
      }
      this.$store.dispatch('PROFILE_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
    },
    onSaved: function() {
      window.localStorage.setItem('profile_image_path', this.profile.attributes['profile-image-path'])
      this.goBack()
    },
    onClickCancel: function() {
      this.goBack()
    },
    goBack: function () {
      if (window.sessionStorage.getItem('profile_edit_referrer')) {
        var referrer = window.sessionStorage.getItem('profile_edit_referrer')
        window.sessionStorage.removeItem('profile_edit_referrer')
        this.$router.push({ path: referrer})
      } else {
        this.$router.go(-1)
      }
    },
    rmEmoji: function(text, data) {
      if (data == 'singleWord') {
        this.singleWord = utils.removeEmoji(text)
      } else if (data == 'specialSkill') {
        this.specialSkill = utils.removeEmoji(text)
      } else if (data == 'hobby') {
        this.hobby = utils.removeEmoji(text)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/profile-edit.js